// 格式化日期
export function formatDate(date: Date | string): string {
  const d = new Date(date)
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
}

// 格式化日期时间
export function formatDateTime(date: Date | string): string {
  const d = new Date(date)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

// 复制文本到剪贴板
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}

// 防抖函数
export function debounce<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null

  return function (this: unknown, ...args: Parameters<T>) {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(this, args), wait)
  }
}

// 节流函数
export function throttle<T extends (...args: unknown[]) => unknown>(
  func: T,
  limit: number
): (...args: Parameters<T>) => void {
  let inThrottle: boolean

  return function (this: unknown, ...args: Parameters<T>) {
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}

// 检查是否为移动设备
export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
}

// 检查是否支持 PWA
export function isPWASupported(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window
}

// 获取检查类型中文名
export function getCheckTypeName(type: string): string {
  return type === 'liquefied_gas' ? '瓶装液化石油气' : '管道天然气'
}

// 获取风险等级中文名和颜色
export function getRiskLevelInfo(level: string): { name: string; color: string } {
  switch (level) {
    case 'high':
      return { name: '高风险', color: '#c62828' }
    case 'medium':
      return { name: '中风险', color: '#ff9800' }
    case 'low':
      return { name: '低风险', color: '#4caf50' }
    default:
      return { name: '未知', color: '#999' }
  }
}

// 获取隐患级别中文名和颜色
export function getHazardLevelInfo(level: string): { name: string; color: string } {
  switch (level) {
    case 'major':
      return { name: '重大隐患', color: '#c62828' }
    case 'general':
      return { name: '一般隐患', color: '#ff9800' }
    default:
      return { name: '未知', color: '#999' }
  }
}
